// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { PriceWithConversionComponent } from './price-with-conversion.component';
import { PriceModule } from '../price/price.module';

@NgModule({
    imports: [
        CommonModule,
        PriceModule,
    ],
    exports: [
        PriceWithConversionComponent,
    ],
    declarations: [
        PriceWithConversionComponent,
    ],
})
export class PriceWithConversionModule { }
